import React from "react";
import PropTypes from "prop-types";
import { Alert, AlertVariants, AlertThemes } from "@sunwing/wvi-components";
import { iconsList } from "@sunwing/icons/westjet-vacations";
import { LinkConnector } from "../LinkConnector";
import { RichTextConnector } from "../RichTextConnector";
import { RCL as useTranslation } from "../../components/RCL";

const AlertBannerConnector = ({ data }) => {
	let variant;

	switch (data.alertVariant) {
		case "Error":
			variant = AlertVariants.error;
			break;
		case "Success":
			variant = AlertVariants.success;
			break;
		case "Warning":
			variant = AlertVariants.warning;
			break;
		case "General":
			variant = AlertVariants.general;
			break;
		case "Info":
		default:
			variant = AlertVariants.info;
			break;
	}

	let theme;

	switch (data.theme) {
		case "Dark":
			theme = AlertThemes.dark;
			break;
		case "Light":
		default:
			theme = AlertThemes.light;
			break;
	}

	return (
		<Alert
			heading={data.displayTitle}
			variant={variant}
			theme={theme}
			dismissible={data.dismissible}
			dismissibleLabel={useTranslation({ searchKey: "close-alert" })}
			noIcon={data.noIcon}
			icon={data.iconObject?.icon}
			renderLink={(href, { children, ...linkProps }) => (
				// eslint-disable-next-line react/jsx-props-no-spreading
				<LinkConnector to={href} noStyle={true} {...linkProps}>
					{children}
				</LinkConnector>
			)}
			link={
				data.link
					? {
							linkText: data.link.linkText,
							href: data.link.url,
						}
					: undefined
			}>
			{data.content && <RichTextConnector data={data.content} />}
		</Alert>
	);
};

AlertBannerConnector.propTypes = {
	data: PropTypes.shape({
		displayTitle: PropTypes.string,
		alertVariant: PropTypes.oneOf(["Warning", "Error", "Info", "Success", "General"]),
		theme: PropTypes.oneOf(["Light", "Dark"]),
		content: PropTypes.shape({
			raw: PropTypes.string,
		}),
		dismissible: PropTypes.bool,
		noIcon: PropTypes.bool,
		iconObject: PropTypes.shape({
			icon: PropTypes.oneOf(iconsList),
		}),
		link: PropTypes.shape({
			linkText: PropTypes.string,
			url: PropTypes.string.isRequired,
		}),
	}).isRequired,
};

export { AlertBannerConnector };
